//#region src/dom/locale/subscribe-ambient-lang.ts
const subscribers = /* @__PURE__ */ new Set();
let observer;
let queued = false;
const flush = () => {
	queued = false;
	for (const cb of subscribers) cb();
};
const schedule = () => {
	if (!queued) {
		queued = true;
		queueMicrotask(flush);
	}
};
function start() {
	if (observer || typeof document === "undefined") return;
	observer = new MutationObserver(schedule);
	observer.observe(document.documentElement, {
		subtree: true,
		attributes: true,
		attributeFilter: ["lang"],
		childList: true
	});
}
function stop() {
	if (subscribers.size || !observer) return;
	observer.disconnect();
	observer = void 0;
	queued = false;
}
/**
* Subscribes to DOM updates that can change inherited `lang`: any `lang` attribute edit, or subtree structural changes
* under `<html>` (which can move nodes between labeled ancestors).
*/
function subscribeAmbientLang(onStoreChange) {
	if (typeof document === "undefined") return () => {};
	subscribers.add(onStoreChange);
	start();
	return () => {
		subscribers.delete(onStoreChange);
		stop();
	};
}
//#endregion
export { subscribeAmbientLang };

//# sourceMappingURL=subscribe-ambient-lang.js.map